import { luscinia } from "../../luscinia";

luscinia.transferKeyToSupplier = async function () {
    const response = await fetch("/data/keys/transfer-key-to-supplier", {
        method: "POST",
        body: luscinia.serializeFormObject($("form#transfer-key-to-supplier"))
    })

    handleResponse(response);
};

luscinia.transferKeyToCustomer = async function () {
    const response = await fetch("/data/keys/transfer-key-to-customer", {
        method: "POST",
        body: luscinia.serializeFormObject($("form#transfer-key-to-customer"))
    })

    await handleResponse(response);
};

luscinia.transferKeyToEmployee = async function () {
    const response = await fetch("/data/keys/transfer-key-to-employee", {
        method: "POST",
        body: luscinia.serializeFormObject($("form#transfer-key-to-employee"))
    })

    await handleResponse(response);
};

luscinia.transferKeyToStorage = async function(keyId) {
    luscinia.showConfirmationDialog("Are you sure?", "The key will be transferred to storage", async () => {
        const response = await fetch(`/data/keys/transfer-key-to-storage/${keyId}`, {
            method: "POST"
        })
    
        await handleResponse(response);
    });
}

async function handleResponse(response: Response) {
    if (response.ok) {
        ($("table[data-luscinia-tablename='Keys']") as any).bootgrid("reload");
        luscinia.closeAllModals();
        luscinia.showNotification("Success", "Key transferred successfully", "success");
    } else {
        luscinia.showNotification("Error", await response.text(), "danger");
    }
}

